/* eslint arrow-body-style: 0 */
import ConversationView from './ConversationView';
import { frontendURL } from '../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/dashboard'),
      name: 'home',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant', 'embed'],
      component: ConversationView,
      props: () => {
        return { inboxId: 0 };
      },
    },
    {
      path: frontendURL('accounts/:accountId/conversations/:conversation_id'),
      name: 'inbox_conversation',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant', 'embed'],
      component: ConversationView,
      props: route => {
        return { 
          inboxId: 0, 
          conversationId: route.params.conversation_id,
          embedding: route.query.embedding,
        };
      },
    },
    {
      path: frontendURL('accounts/:accountId/inbox/:inbox_id'),
      name: 'inbox_dashboard',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => {
        return { inboxId: route.params.inbox_id };
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/inbox/:inbox_id/conversations/:conversation_id'
      ),
      name: 'conversation_through_inbox',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => {
        return {
          conversationId: route.params.conversation_id,
          inboxId: route.params.inbox_id,
        };
      },
    },
    {
      path: frontendURL('accounts/:accountId/label/:label'),
      name: 'label_conversations',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({ label: route.params.label }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/label/:label/conversations/:conversation_id'
      ),
      name: 'conversations_through_label',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversation_id,
        label: route.params.label,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/product_label/:product_label'),
      name: 'product_label_conversations',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({ productLabel: route.params.product_label }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/product_label/:product_label/conversations/:conversation_id'
      ),
      name: 'conversations_through_product_label',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversation_id,
        productLabel: route.params.product_label,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/topic_label/:topic_label'),
      name: 'topic_label_conversations',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({ topicLabel: route.params.topic_label }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/topic_label/:topic_label/conversations/:conversation_id'
      ),
      name: 'conversations_through_topic_label',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversation_id,
        topicLabel: route.params.topic_label,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/concurrent_label/:concurrent_label'),
      name: 'concurrent_label_conversations',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({ concurrentLabel: route.params.concurrent_label }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/concurrent_label/:concurrent_label/conversations/:conversation_id'
      ),
      name: 'conversations_through_concurrent_label',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversation_id,
        concurrentLabel: route.params.concurrent_label,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/team/:teamId'),
      name: 'team_conversations',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({ teamId: route.params.teamId }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/team/:teamId/conversations/:conversationId'
      ),
      name: 'conversations_through_team',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        teamId: route.params.teamId,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/custom_view/:id'),
      name: 'folder_conversations',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant', 'embed'],
      component: ConversationView,
      props: route => ({ foldersId: route.params.id }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/custom_view/:id/conversations/:conversation_id'
      ),
      name: 'conversations_through_folders',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversation_id,
        foldersId: route.params.id,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/mentions/conversations'),
      name: 'conversation_mentions',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: () => ({ conversationType: 'mention' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/mentions/conversations/:conversationId'
      ),
      name: 'conversation_through_mentions',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'mention',
      }),
    },
    {
      path: frontendURL('accounts/:accountId/unattended/conversations'),
      name: 'conversation_unattended',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: () => ({ conversationType: 'unattended' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/unattended/conversations/:conversationId'
      ),
      name: 'conversation_through_unattended',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'unattended',
      }),
    },
    {
      path: frontendURL('accounts/:accountId/participating/conversations'),
      name: 'conversation_participating',
      roles: ['administrator', 'agent'],
      component: ConversationView,
      props: () => ({ conversationType: 'participating' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/participating/conversations/:conversationId'
      ),
      name: 'conversation_through_participating',
      roles: ['administrator', 'agent'],
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'participating',
      }),
    },
    {
      path: frontendURL('accounts/:accountId/unread/conversations'),
      name: 'conversation_unread',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: () => ({ conversationType: 'unread' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/unread/conversations/:conversationId'
      ),
      name: 'conversation_through_unread',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'unread',
      }),
    },
    {
      path: frontendURL('accounts/:accountId/lasted/conversations'),
      name: 'conversation_last_message_client',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: () => ({ conversationType: 'lasted' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/lasted/conversations/:conversationId'
      ),
      name: 'conversation_through_last_message_client',
      roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: ConversationView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'lasted',
      }),
    },
  ],
};
